import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Card } from "@rumbledirect/ui";

interface AntdBarChartProps {
  title: string;
  data: Array<Record<string, any>>;
  className?: string;
  dataKeys: string[];
}

const COLORS = [
  "#8B0000", // Dark Red
  "#B22222", // Fire Brick Red
  "#DC143C", // Crimson
  "#FF0000", // Pure Red
  "#FF4500", // Orange Red
  "#FF6600", // Vivid Orange Red
  "#FF7F00", // Dark Orange
  "#FF8C00", // Dark Orange 2
  "#FFA500", // Orange
  "#FFB347", // Peach Orange
  "#FFC0CB", // Light Orange
  "#FFD700", // Gold
  "#A52A2A", // Brown Red
  "#CD5C5C", // Indian Red
  "#F08080", // Light Coral
  "#FA8072", // Salmon
  "#FF69B4", // Hot Pink Red
  "#FF1493", // Deep Pink Red
  "#B8860B", // Dark Goldenrod
  "#DAA520", // Goldenrod
  "#FF7F50", // Coral
  "#FF6347", // Tomato
  "#FF4040", // Bright Red
  "#D2691E", // Chocolate Orange
];

export const AntdBarChart = ({
  title,
  data,
  className,
  dataKeys,
}: AntdBarChartProps) => {
  return (
    <Card className={className} title={title}>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
        >
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickLine={false}
            tickMargin={8}
            axisLine={false}
            angle={-60}
            height={100}
            interval={0}
            textAnchor="end"
          />
          <YAxis />
          <Tooltip />
          {dataKeys.map((key, index) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="a"
              fill={COLORS[index % COLORS.length]}
              name={key}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
